import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TimeEditPopoverComponent } from './time-edit-popover.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@app/material.module';
import { SatPopoverModule } from '@ncstate/sat-popover';
import { TranslateModule } from '@ngx-translate/core';
import { TimeInputModule } from '@app/shared/time-input/time-input.module';
import { A11yModule } from '@angular/cdk/a11y';
import { DurationInputControlModule } from '../duration-input-control/duration-input-control.module';

@NgModule({
  declarations: [TimeEditPopoverComponent],
  imports: [
    CommonModule,
    SatPopoverModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    ScrollingModule,
    TranslateModule,
    TimeInputModule,
    DurationInputControlModule,
    A11yModule,
  ],
  exports: [TimeEditPopoverComponent],
})
export class TimeEditPopoverModule {}
